<script>
  import { createEventDispatcher } from 'svelte';
  import { link } from '../svelte-navigator';
  import Fa from 'svelte-fa';
  import { faHome } from '@fortawesome/free-solid-svg-icons';
  import { Grid, Loading, Notification } from '../components';
  import { numberWithDigitGrouping } from '../utils.js';
  import { getQuery, runQuery, getQueryColumns, getTotalMarketAvailability } from '../data.js';

  const dispatch = createEventDispatcher();

  export let id = null;
  export let showDelete = false;

  let componentQuery;

  async function getData() {
    componentQuery = await getQuery(id);
    const parts = await runQuery(id);
    const columns = getQueryColumns();
    const totalMarketAvailability = getTotalMarketAvailability(parts);
    return { parts, columns, totalMarketAvailability };
  }

  function onDelete(id) {
    dispatch('delete', { id });
  }
</script>

<svelte:head>
  <title>Query {componentQuery?.Name || ""}</title>
  <html lang="en" />
</svelte:head>

{#await getData()}
  <Loading visible />
{:then data}
  <div class="container">
    <div class="toolbar">
      <a href="/" use:link><Fa icon={faHome} color="#666" /></a>
      <div class="component">
        {componentQuery?.Name || ""}
        {componentQuery?.Tags ? `(${componentQuery?.Tags})` : ""}
      </div> 
      <span>{`TOTAL STOCK: ${numberWithDigitGrouping(data.totalMarketAvailability)}`}</span>
    </div>
    <Grid data={data.parts} columns={data.columns} banded sortable deletable={showDelete} deleteOnLeft on:delete={(e) => onDelete(data[e.detail.index].ID)} />
  </div>
{:catch error}
  <Notification icon="error" message={error.message} visible />
{/await}


<style>
  .container {
    display: grid;
    grid-template-rows: 32px calc(100% - 42px);
    width: 100%;
    height: 100vh;
  }

  .toolbar {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
    padding: 0px 0px 5px 5px;
  }

  .component {
    color: dimgray;
  }
</style>